import {
  ChartOfAccounts,
  CoAManagedType,
  CoAManagingApplication,
  CoaTree,
  LedgerType,
} from "../apiHooks/chartOfAccounts/chartOfAccounts.types";
import { NOCODE } from "../apiHooks/chartOfAccounts/chartOfAccounts.constants";

export const getCoaBreakdownTrees = (trees: CoaTree[]) => trees.filter((tree) => !tree.ledger_type && tree.enabled);

export const getCoaLedgerTrees = (trees: CoaTree[], ledgerType: LedgerType) =>
  trees.filter((tree) => tree.ledger_type === ledgerType);

export const getCoaBreakdownAndLedgerTrees = (trees: CoaTree[], ledgerType: LedgerType) =>
  trees.filter((tree) => (!tree.ledger_type && tree.enabled) || tree.ledger_type === ledgerType);

export const checkIsNocodeAccountCode = (accountCode: string) => accountCode === NOCODE;

export const checkIsFinCoA = (coa: ChartOfAccounts) =>
  coa.managed_type === CoAManagedType.Application && coa.managing_application === CoAManagingApplication.Financials;
